import { UserCog } from 'lucide-react';
import { LeadUpdatedEvent as LeadUpdatedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: LeadUpdatedEventType;
}

export default function LeadUpdatedEvent({ event }: Props) {
  return (
    <EventShell
      color="green"
      icon={<UserCog className="w-3.5 h-3.5" />}
      title="Contact Updated"
      timestamp={event.created_at}
    >
      {event.payload.updated_fields && event.payload.updated_fields.length > 0 && (
        <p>Updated: {event.payload.updated_fields.join(', ')}</p>
      )}
    </EventShell>
  );
}
